/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EstadoCandidaturaEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const EstadoCandidaturaEnum = {

    NUMBER_1: 1 as EstadoCandidaturaEnum,

    NUMBER_2: 2 as EstadoCandidaturaEnum,

    NUMBER_3: 3 as EstadoCandidaturaEnum,

    NUMBER_4: 4 as EstadoCandidaturaEnum,

    NUMBER_5: 5 as EstadoCandidaturaEnum,

    NUMBER_6: 6 as EstadoCandidaturaEnum
};

